import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";
import { Settings } from "../../types/SettingsTypes";

export default function useGetSettings() {
  return useQuery({
    queryKey: ["settings"],
    queryFn: async () => {
      return axiosInstance.get("/settings").then((res) => res.data);
    },
    select: (data: Settings) => data,
    retry: false,
  });
}
